import { AxiosInstance } from "axios";
import { SignInDto } from "../types/auth/sign-in-dto";
import { SignInPayload } from "../types/auth/sign-in-payload";
import { ongBaseApi } from "./ong-base-api";
import { OngBaseResponse } from "./ong-base-response";

export enum AuthApiUrl {
  SignInAdmin = "/auth/sign-in/admin",
}

class AuthApi {
  private _api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this._api = api;
  }

  async signInAdmin(
    payload: SignInPayload
  ): Promise<OngBaseResponse<SignInDto>> {
    return await this._api.post(AuthApiUrl.SignInAdmin, payload);
  }
}

export const authApi = new AuthApi(ongBaseApi);
